/**
 * * Add functionality by wrapping with FileDropOrBrowse HOC.
 * */
import * as React from "react"
import PropTypes from "prop-types"
import "./FileUploadContent.scss"

const FileUploadContent = ({ isDragging, hasError, disabled = false, hasPermission = true, className }) => {
  return (
    <div
      className={`file-upload-content${hasError ? " error" : ""}${isDragging ? " dragging" : ""}${className ? ` ${className}` : ""}${disabled || !hasPermission ? " disabled" : ""}`}
    >
      <i className="fal fa-cloud-upload" />
      {hasPermission ? (
        <div className="file-upload-content-text">
          Drag &amp; drop to upload or <span className="link">browse</span>*
        </div>
      ) : (
        <div>You do not have permission to upload files. Please speak to an admin.</div>
      )}
    </div>
  )
}

FileUploadContent.propTypes = {
  isDragging: PropTypes.bool,
  hasError: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

export default FileUploadContent
